import { getRowKeyIter } from '../config/utils'
const checkboxMethods = {
  setIndeterminateOnSelect() {
    this.states.selectOnIndeterminate = !!this.selection.size && !this.states.isAllSelected
  },
  newSelection() {
    this.selection = new Set()
    // 保留历史的勾选时，存储的数据
    if (this.table.$props.reserveSelection) {
      this.selectionMap = new Map()
    }
  },
  setSelection (selection) {
    const { rowKey } = this.states
    this.selection = selection
    // 保留历史的勾选时，存储的数据
    if (this.table.$props.reserveSelection) {
      for (let i = 0; i < this._checkboxData.length; i++) {
        const row = this._checkboxData[i]
        const uniqueId = getRowKeyIter(this._checkboxData[i], rowKey)
        if (selection.has(uniqueId)) {
          this.selectionMap.set(uniqueId, row)
        }
      }
    }
  },
  addSelection(uniqueId, rowData) {
    this.selection.add(uniqueId)
    // 保留历史的勾选时，增加存储的数据
    if (this.table.$props.reserveSelection) {
      this.selectionMap.set(uniqueId, rowData)
    }
  },
  deleteSelection(uniqueId) {
    this.selection.delete(uniqueId)
    // 保留历史的勾选时，删除存储的数据
    if (this.table.$props.reserveSelection) {
      this.selectionMap.delete(uniqueId)
    }
  },
  clearSelection() {
    this.resetSelectionValue()
    this.updateAllSelected()
    this.updateSelectCheckbox()
  },
  resetSelectionValue() {
    this.newSelection()
    this.states.isAllSelected = false
    this.states.selectOnIndeterminate = false
  },
  updateSelectCheckbox() {
    this.states.UPDATE_checkbox.sum += 1
  },
  emitsControlOnSelection(isAllSelectByClick = false) {
    let selection = this.getSelectionRows()
    let unSelection = this.getUnSelectionRows()
    const { isAllSelected } = this.states
    this.table.$emit('selection-change', selection || [], isAllSelected, unSelection)
    this.table.$emit('select-all', selection, isAllSelected, isAllSelectByClick, unSelection)
  },
  toggleAllSelection() {
    const states = this.states
    const { isAllSelected, selectOnIndeterminate } = states
    const value = selectOnIndeterminate ? !isAllSelected : !(isAllSelected || this.selection.size)
    this.states.isAllSelected = value
    this.toggleAllSelectionRows(value, true)
  },
  toggleAllSelectionRows(value, isAllSelectByClick) {
    const states = this.states
    const { reserveSelection } = this.table.$props
    const { rowKey } = states
    if (!reserveSelection) {
      if (value) {
        // 优化普通的类似 比如 id
        for (let i = 0; i < this._checkboxData.length; i++) {
          const row = this._checkboxData[i]
          const uniqueId = getRowKeyIter(this._checkboxData[i], rowKey)
          const disabled = this.table.selectable ? !this.table.selectable.call(null, row, i) : false
          if (!disabled) {
            this.addSelection(uniqueId, row)
          }
        }
      } else {
        this.newSelection()
      }
    } else {
      for (let i = 0; i < this._checkboxData.length; i++) {
        const row = this._checkboxData[i]
        const uniqueId = getRowKeyIter(this._checkboxData[i], rowKey)
        const disabled = this.table.selectable ? !this.table.selectable.call(null, row, i) : false
        if (!value) {
          if (!this.selection.has(uniqueId) && !disabled) {
            continue
          } else {
            this.deleteSelection(uniqueId)
          }
        } else {
          !disabled && this.addSelection(uniqueId, row)
        }
      }
    }
    this.updateSelectCheckbox()
    this.setIndeterminateOnSelect()
    this.emitsControlOnSelection(isAllSelectByClick)
  },
  addOrReduceOnselection(row, selected) {
    const rowKey = this.table.$props.rowKey
    const uniqueId = getRowKeyIter(row, rowKey)
    this.changeCheckboxRowSelection(uniqueId, selected, row)
  },
  changeCheckboxRowSelection(uniqueId, selected, row) {
    // 使用方法
    if (selected) {
      this.addSelection(uniqueId, row)
    } else {
      this.deleteSelection(uniqueId)
    }
  },
  deepChangeSelection(_checkboxRowData, selected, childrenKeyName) {
    if (!_checkboxRowData) {
      return
    }
    // 如果是树结构的，还需要处理子级以及父级的状态
    this.addOrReduceOnselection(_checkboxRowData, selected)
    const children = _checkboxRowData[childrenKeyName]
    if (this.table.$props.expandColumnKey) {
      if (children && children.length) {
        children.forEach(child => {
          const disabled = this.table.selectable ? !this.table.selectable.call(null, child, child._index) : false
          if (!disabled) {
            this.deepChangeSelection(child, selected, childrenKeyName)
          }
        })
      }
    }
  },
  rowSelectedChanged(selected, row, rowIndex, isUserClick) {
    const disabled = this.table.selectable ? !this.table.selectable.call(null, row, rowIndex) : false
    if (!disabled || this.table.$props.checkBoxDisableSelect) {
      const rowKey = this.table.$props.rowKey
      const uniqueId = getRowKeyIter(row, rowKey)
      const _checkboxRowData = this._checkboxData.find(ele => getRowKeyIter(ele, rowKey) === uniqueId)
      const { children: childrenKeyName } = this.table.$props.treeProps
      this.deepChangeSelection(_checkboxRowData, selected, childrenKeyName)
      // 祖先节点的状态变更
      if (this.table.$props.expandColumnKey && _checkboxRowData) {
        const { _parentIds } = _checkboxRowData
        if (_parentIds && _parentIds.length) {
          const reverseParentIds = [..._parentIds].reverse()
          // 需要反推
          reverseParentIds.forEach(parentId => {
            if (selected) {
              // 判断所有的子节点是否都勾上
              const { _childIds: currentChildIds = [] } =
                this._checkboxData.find(ele => getRowKeyIter(ele, rowKey) === parentId) || {}
              const isCheckedAllChid = currentChildIds.length && currentChildIds.every(k => this.selection.has(k))
              if (isCheckedAllChid) {
                let parentRow = null
                // 保留历史的勾选时，才做查找
                if (this.table.$props.reserveSelection) {
                  parentRow = this._checkboxData.find(ele => getRowKeyIter(ele, rowKey) === parentId)
                }
                this.changeCheckboxRowSelection(parentId, true, parentRow)
              }
            } else {
              // 如果有为false,则所有的祖先节点不能被勾选
              this.changeCheckboxRowSelection(parentId, false)
            }
          })
        }
      }
    }
    this.updateAllSelected()
    this.updateSelectCheckbox()
    this.table.$emit('select', row, this.selection, selected, isUserClick)
  },
  updateAllSelected() {
    const selection = this.selection
    const tableData = this._checkboxData || []
    const tableDataLength = tableData.length
    const states = this.states
    if (tableDataLength === 0) {
      states.isAllSelected = false
      return
    }
    states.isAllSelected = !this.table.$props.reserveSelection
      ? tableDataLength === selection.size
      : tableData.every(row => selection.has(getRowKeyIter(row, this.states.rowKey)))
    this.setIndeterminateOnSelect()
    this.emitsControlOnSelection()
  },
  getCheckboxSelection() {
    // 保留历史的勾选时，仅给已勾选的数据
    if (this.table.$props.reserveSelection) {
      const selection = [...this.selection].reduce((acc, uniqueId) => {
        const row = this.selectionMap.get(uniqueId)
        if (row) {
          acc.push(row)
        }
        return acc
      }, [])
      return {
        selection
      }
    }
    const result = this._checkboxData.reduce(
      (obj, row) => {
        const val = getRowKeyIter(row, this.states.rowKey)
        if (this.selection.has(val)) {
          obj.selection.push(row)
        } else {
          obj.unSelection.push(row)
        }
        return obj
      },
      {
        selection: [],
        unSelection: []
      }
    )
    return result
  },
  getUnSelectionRows() {
    const { unSelection } = this.getCheckboxSelection()
    return unSelection
  },
  getSelectionRows() {
    const { selection } = this.getCheckboxSelection()
    return selection
  },
  getSelection() {
    return this.selection
  },
  rowSelectedChangedByClick(row, rowIndex) {
    const states = this.states
    const { rowKey } = states
    const uniqueId = getRowKeyIter(row, rowKey)
    const selection = this.getSelection()
    const value = selection.has(uniqueId)
    this.rowSelectedChanged(!value, row, rowIndex, true)
  }
}

export default {
  data() {
    return {
      states: {
        isAllSelected: false, // 是否全选
        selectOnIndeterminate: false,
        // reserveSelection: false, // 是否保留历史的勾选，比如数据替换之后
        UPDATE_checkbox: {
          sum: 0
        }
      }
    }
  },
  methods: checkboxMethods
}

export function checkboxData(formatDataResult, { store, table, dataInstanceChanged } = {}) {
  try {
    const { rowKey, mergeRowspanMaps, isAllSelected } = store.states
    const { treeProps, showSelection, expandColumnKey, reserveSelection } = table.$props
    const { children: childrenKeyName } = treeProps
    if (!showSelection) return { ...formatDataResult, checkboxData: formatDataResult.tableData }
    const array = []
    let stack = formatDataResult.tableData.slice()
    const keysSet = new Set()
    const mergeRowMapsValues = Object.values(mergeRowspanMaps)
    // 未保留历史的勾选时，删除存储的数据, 前提是在数据变化的时候
    if (dataInstanceChanged) {
      if (isAllSelected && !reserveSelection) {
        store.selection = new Set() // 这里重新创建，防止引用
      }
    }
    // 递归处理，对需要展开的子级做铺平展开
    recursionFlatten(array, stack, expandColumnKey, rowKey, keysSet, childrenKeyName, mergeRowMapsValues)
    return { ...formatDataResult, checkboxData: array }
  } catch (error) {
    console.error('Table2多选数据生成错误：', error)
    return { ...formatDataResult }
  }
}

function recursionFlatten(
  data,
  stack,
  expandColumnKey,
  rowKey,
  keysSet,
  childrenKeyName,
  mergeRowMapsValues = [],
  parentIds = []
) {
  const mergeRowCllback = {}
  for (let i = 0; i < stack.length; i++) {
    const row = stack[i]
    const key = getRowKeyIter(row, rowKey)
    if (!keysSet.has(key)) {
      data.push(row)
      keysSet.add(key)
    }
    if (parentIds.length) {
      row['_parentIds'] = [...parentIds]
    }
    const children = row[childrenKeyName]
    if (expandColumnKey && Array.isArray(children) && children.length > 0) {
      row['_childIds'] = children.map(child => getRowKeyIter(child, rowKey))
      const mergeRowInfo = mergeRowMapsValues.find(item => [item.mergeStartIndex, item.mergeEndIndex].includes(i))
      const _addDataCallback = () =>
        recursionFlatten(data, children, expandColumnKey, rowKey, keysSet, childrenKeyName, mergeRowMapsValues, [
          ...(row['_parentIds'] || []),
          key
        ])
      // 合并行命中
      if (mergeRowInfo) {
        const { mergeStartIndex, mergeEndIndex } = mergeRowInfo
        if (mergeStartIndex === i) {
          mergeRowCllback[`${mergeEndIndex}`] = _addDataCallback
        }
      } else {
        _addDataCallback()
      }
    }
    const _addDataCallback = mergeRowCllback[i]
    if (_addDataCallback) {
      _addDataCallback()
      mergeRowCllback[i] = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/checkbox.js